import { CommonModule } from '@angular/common';
import { Validators, NG_VALIDATORS } from '@angular/forms';
import { Directive, forwardRef, Pipe, NgModule } from '@angular/core';
import { utilsBr, validateBr, maskBr } from 'js-brasil';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ cpf = function (control) {
    if (utilsBr.isPresent(Validators.required(control))) {
        return null;
    }
    var /** @type {?} */ v = control.value;
    return validateBr.cpf(v) ? null : { cpf: true };
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ CPF_VALIDATOR = {
    provide: NG_VALIDATORS,
    // tslint:disable-next-line: no-use-before-declare
    useExisting: forwardRef(function () { return CPFValidator; }),
    multi: true
};
var CPFValidator = /** @class */ (function () {
    function CPFValidator() {
    }
    /**
     * @param {?} c
     * @return {?}
     */
    CPFValidator.prototype.validate = /**
     * @param {?} c
     * @return {?}
     */
    function (c) {
        return cpf(c);
    };
    CPFValidator.decorators = [
        { type: Directive, args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[cpf][formControlName],[cpf][formControl],[cpf][ngModel]',
                    providers: [CPF_VALIDATOR]
                },] }
    ];
    /** @nocollapse */
    CPFValidator.ctorParameters = function () { return []; };
    return CPFValidator;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var CPFPipe = /** @class */ (function () {
    function CPFPipe() {
    }
    /**
     * @param {?} cpfValue
     * @return {?}
     */
    CPFPipe.prototype.transform = /**
     * @param {?} cpfValue
     * @return {?}
     */
    function (cpfValue) {
        return maskBr.cpf(cpfValue);
    };
    CPFPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'cpf',
                },] }
    ];
    /** @nocollapse */
    CPFPipe.ctorParameters = function () { return []; };
    return CPFPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ cnpj = function (control) {
    if (utilsBr.isPresent(Validators.required(control))) {
        return null;
    }
    var /** @type {?} */ v = control.value;
    return validateBr.cnpj(v) ? null : { cnpj: true };
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ CNPJ_VALIDATOR = {
    provide: NG_VALIDATORS,
    // tslint:disable-next-line: no-use-before-declare
    useExisting: forwardRef(function () { return CNPJValidator; }),
    multi: true
};
var CNPJValidator = /** @class */ (function () {
    function CNPJValidator() {
    }
    /**
     * @param {?} c
     * @return {?}
     */
    CNPJValidator.prototype.validate = /**
     * @param {?} c
     * @return {?}
     */
    function (c) {
        return cnpj(c);
    };
    CNPJValidator.decorators = [
        { type: Directive, args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[cnpj][formControlName],[cnpj][formControl],[cnpj][ngModel]',
                    providers: [CNPJ_VALIDATOR]
                },] }
    ];
    /** @nocollapse */
    CNPJValidator.ctorParameters = function () { return []; };
    return CNPJValidator;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var CNPJPipe = /** @class */ (function () {
    function CNPJPipe() {
    }
    /**
     * @param {?} cnpjValue
     * @return {?}
     */
    CNPJPipe.prototype.transform = /**
     * @param {?} cnpjValue
     * @return {?}
     */
    function (cnpjValue) {
        return maskBr.cnpj(cnpjValue);
    };
    CNPJPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'cnpj',
                },] }
    ];
    /** @nocollapse */
    CNPJPipe.ctorParameters = function () { return []; };
    return CNPJPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ telefone = function (control) {
    if (utilsBr.isPresent(Validators.required(control))) {
        return null;
    }
    var /** @type {?} */ v = control.value;
    return validateBr.telefone(v) ? null : { telefone: true };
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ TELEFONE_VALIDATOR = {
    provide: NG_VALIDATORS,
    // tslint:disable-next-line: no-use-before-declare
    useExisting: forwardRef(function () { return TelefoneValidator; }),
    multi: true
};
var TelefoneValidator = /** @class */ (function () {
    function TelefoneValidator() {
    }
    /**
     * @param {?} c
     * @return {?}
     */
    TelefoneValidator.prototype.validate = /**
     * @param {?} c
     * @return {?}
     */
    function (c) {
        return telefone(c);
    };
    TelefoneValidator.decorators = [
        { type: Directive, args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[telefone][formControlName],[telefone][formControl],[telefone][ngModel]',
                    providers: [TELEFONE_VALIDATOR]
                },] }
    ];
    /** @nocollapse */
    TelefoneValidator.ctorParameters = function () { return []; };
    return TelefoneValidator;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var TelefonePipe = /** @class */ (function () {
    function TelefonePipe() {
    }
    /**
     * @param {?} telefoneValue
     * @return {?}
     */
    TelefonePipe.prototype.transform = /**
     * @param {?} telefoneValue
     * @return {?}
     */
    function (telefoneValue) {
        return maskBr.telefone(telefoneValue);
    };
    TelefonePipe.decorators = [
        { type: Pipe, args: [{
                    name: 'telefone',
                },] }
    ];
    /** @nocollapse */
    TelefonePipe.ctorParameters = function () { return []; };
    return TelefonePipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ celular = function (control) {
    if (utilsBr.isPresent(Validators.required(control))) {
        return null;
    }
    var /** @type {?} */ v = control.value;
    return validateBr.celular(v) ? null : { celular: true };
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ CELULAR_VALIDATOR = {
    provide: NG_VALIDATORS,
    // tslint:disable-next-line: no-use-before-declare
    useExisting: forwardRef(function () { return CelularValidator; }),
    multi: true
};
var CelularValidator = /** @class */ (function () {
    function CelularValidator() {
    }
    /**
     * @param {?} c
     * @return {?}
     */
    CelularValidator.prototype.validate = /**
     * @param {?} c
     * @return {?}
     */
    function (c) {
        return celular(c);
    };
    CelularValidator.decorators = [
        { type: Directive, args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[celular][formControlName],[celular][formControl],[celular][ngModel]',
                    providers: [CELULAR_VALIDATOR]
                },] }
    ];
    /** @nocollapse */
    CelularValidator.ctorParameters = function () { return []; };
    return CelularValidator;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var CelularPipe = /** @class */ (function () {
    function CelularPipe() {
    }
    /**
     * @param {?} celularValue
     * @return {?}
     */
    CelularPipe.prototype.transform = /**
     * @param {?} celularValue
     * @return {?}
     */
    function (celularValue) {
        return maskBr.celular(celularValue);
    };
    CelularPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'celular',
                },] }
    ];
    /** @nocollapse */
    CelularPipe.ctorParameters = function () { return []; };
    return CelularPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ inscricaoestadual = function (estado) {
    return function (control) {
        if (utilsBr.isPresent(Validators.required(control))) {
            return null;
        }
        var /** @type {?} */ v = control.value;
        return validateBr.inscricaoestadual(v, estado) ? null : { inscricaoestadual: true };
    };
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ INSCRICAOESTADUAL_VALIDATOR = {
    provide: NG_VALIDATORS,
    // tslint:disable-next-line: no-use-before-declare
    useExisting: forwardRef(function () { return InscricaoEstadualValidator; }),
    multi: true
};
var InscricaoEstadualValidator = /** @class */ (function () {
    function InscricaoEstadualValidator() {
    }
    /**
     * @param {?} c
     * @return {?}
     */
    InscricaoEstadualValidator.prototype.validate = /**
     * @param {?} c
     * @return {?}
     */
    function (c) {
        return inscricaoestadual('mg')(c);
    };
    InscricaoEstadualValidator.decorators = [
        { type: Directive, args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[inscricaoestadual][formControlName],[inscricaoestadual][formControl],[inscricaoestadual][ngModel]',
                    providers: [INSCRICAOESTADUAL_VALIDATOR]
                },] }
    ];
    /** @nocollapse */
    InscricaoEstadualValidator.ctorParameters = function () { return []; };
    return InscricaoEstadualValidator;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var InscricaoEstadualPipe = /** @class */ (function () {
    function InscricaoEstadualPipe() {
    }
    /**
     * @param {?} inscricaoestadualValue
     * @param {?} estado
     * @return {?}
     */
    InscricaoEstadualPipe.prototype.transform = /**
     * @param {?} inscricaoestadualValue
     * @param {?} estado
     * @return {?}
     */
    function (inscricaoestadualValue, estado) {
        return maskBr.inscricaoestadual(inscricaoestadualValue, estado);
    };
    InscricaoEstadualPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'inscricaoestadual',
                },] }
    ];
    /** @nocollapse */
    InscricaoEstadualPipe.ctorParameters = function () { return []; };
    return InscricaoEstadualPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ cep = function (control) {
    if (utilsBr.isPresent(Validators.required(control))) {
        return null;
    }
    var /** @type {?} */ v = control.value;
    return validateBr.cep(v) ? null : { cep: true };
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ CEP_VALIDATOR = {
    provide: NG_VALIDATORS,
    // tslint:disable-next-line: no-use-before-declare
    useExisting: forwardRef(function () { return CEPValidator; }),
    multi: true
};
var CEPValidator = /** @class */ (function () {
    function CEPValidator() {
    }
    /**
     * @param {?} c
     * @return {?}
     */
    CEPValidator.prototype.validate = /**
     * @param {?} c
     * @return {?}
     */
    function (c) {
        return cep(c);
    };
    CEPValidator.decorators = [
        { type: Directive, args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[cep][formControlName],[cep][formControl],[cep][ngModel]',
                    providers: [CEP_VALIDATOR]
                },] }
    ];
    /** @nocollapse */
    CEPValidator.ctorParameters = function () { return []; };
    return CEPValidator;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var CEPPipe = /** @class */ (function () {
    function CEPPipe() {
    }
    /**
     * @param {?} cepValue
     * @return {?}
     */
    CEPPipe.prototype.transform = /**
     * @param {?} cepValue
     * @return {?}
     */
    function (cepValue) {
        return maskBr.cep(cepValue);
    };
    CEPPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'cep',
                },] }
    ];
    /** @nocollapse */
    CEPPipe.ctorParameters = function () { return []; };
    return CEPPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ currency = function (control) {
    if (utilsBr.isPresent(Validators.required(control))) {
        return null;
    }
    var /** @type {?} */ v = control.value;
    return validateBr.currency(v) ? null : { currency: true };
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ CURRENCY_VALIDATOR = {
    provide: NG_VALIDATORS,
    // tslint:disable-next-line: no-use-before-declare
    useExisting: forwardRef(function () { return CURRENCYValidator; }),
    multi: true
};
var CURRENCYValidator = /** @class */ (function () {
    function CURRENCYValidator() {
    }
    /**
     * @param {?} c
     * @return {?}
     */
    CURRENCYValidator.prototype.validate = /**
     * @param {?} c
     * @return {?}
     */
    function (c) {
        return currency(c);
    };
    CURRENCYValidator.decorators = [
        { type: Directive, args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[currency][formControlName],[currency][formControl],[currency][ngModel]',
                    providers: [CURRENCY_VALIDATOR]
                },] }
    ];
    /** @nocollapse */
    CURRENCYValidator.ctorParameters = function () { return []; };
    return CURRENCYValidator;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var CURRENCYPipe = /** @class */ (function () {
    function CURRENCYPipe() {
    }
    /**
     * @param {?} currencyValue
     * @return {?}
     */
    CURRENCYPipe.prototype.transform = /**
     * @param {?} currencyValue
     * @return {?}
     */
    function (currencyValue) {
        return maskBr.currency(currencyValue);
    };
    CURRENCYPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'currencyBrazil',
                },] }
    ];
    /** @nocollapse */
    CURRENCYPipe.ctorParameters = function () { return []; };
    return CURRENCYPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ number = function (control) {
    if (utilsBr.isPresent(Validators.required(control))) {
        return null;
    }
    var /** @type {?} */ v = control.value;
    return validateBr.number(v) ? null : { number: true };
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ NUMBER_VALIDATOR = {
    provide: NG_VALIDATORS,
    // tslint:disable-next-line: no-use-before-declare
    useExisting: forwardRef(function () { return NUMBERValidator; }),
    multi: true
};
var NUMBERValidator = /** @class */ (function () {
    function NUMBERValidator() {
    }
    /**
     * @param {?} c
     * @return {?}
     */
    NUMBERValidator.prototype.validate = /**
     * @param {?} c
     * @return {?}
     */
    function (c) {
        return number(c);
    };
    NUMBERValidator.decorators = [
        { type: Directive, args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[number][formControlName],[number][formControl],[number][ngModel]',
                    providers: [NUMBER_VALIDATOR]
                },] }
    ];
    /** @nocollapse */
    NUMBERValidator.ctorParameters = function () { return []; };
    return NUMBERValidator;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var NUMBERPipe = /** @class */ (function () {
    function NUMBERPipe() {
    }
    /**
     * @param {?} numberValue
     * @return {?}
     */
    NUMBERPipe.prototype.transform = /**
     * @param {?} numberValue
     * @return {?}
     */
    function (numberValue) {
        return maskBr.number(numberValue);
    };
    NUMBERPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'numberBrazil',
                },] }
    ];
    /** @nocollapse */
    NUMBERPipe.ctorParameters = function () { return []; };
    return NUMBERPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ placa = function (control) {
    if (utilsBr.isPresent(Validators.required(control))) {
        return null;
    }
    var /** @type {?} */ v = control.value;
    return validateBr.placa(v) ? null : { placa: true };
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ PLACA_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(function () { return PLACAValidator; }),
    multi: true
};
var PLACAValidator = /** @class */ (function () {
    function PLACAValidator() {
    }
    /**
     * @param {?} c
     * @return {?}
     */
    PLACAValidator.prototype.validate = /**
     * @param {?} c
     * @return {?}
     */
    function (c) {
        return placa(c);
    };
    PLACAValidator.decorators = [
        { type: Directive, args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[placa][formControlName],[placa][formControl],[placa][ngModel]',
                    providers: [PLACA_VALIDATOR]
                },] }
    ];
    /** @nocollapse */
    PLACAValidator.ctorParameters = function () { return []; };
    return PLACAValidator;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PLACAPipe = /** @class */ (function () {
    function PLACAPipe() {
    }
    /**
     * @param {?} placaValue
     * @return {?}
     */
    PLACAPipe.prototype.transform = /**
     * @param {?} placaValue
     * @return {?}
     */
    function (placaValue) {
        return maskBr.placa(placaValue);
    };
    PLACAPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'placa'
                },] }
    ];
    /** @nocollapse */
    PLACAPipe.ctorParameters = function () { return []; };
    return PLACAPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ porcentagem = function (control) {
    if (utilsBr.isPresent(Validators.required(control))) {
        return null;
    }
    var /** @type {?} */ v = control.value;
    return validateBr.porcentagem(v) ? null : { porcentagem: true };
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ PERCENTAGE_VALIDATOR = {
    provide: NG_VALIDATORS,
    // tslint:disable-next-line: no-use-before-declare
    useExisting: forwardRef(function () { return PERCENTAGEValidator; }),
    multi: true
};
var PERCENTAGEValidator = /** @class */ (function () {
    function PERCENTAGEValidator() {
    }
    /**
     * @param {?} c
     * @return {?}
     */
    PERCENTAGEValidator.prototype.validate = /**
     * @param {?} c
     * @return {?}
     */
    function (c) {
        return porcentagem(c);
    };
    PERCENTAGEValidator.decorators = [
        { type: Directive, args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[percentage][formControlName],[percentage][formControl],[percentage][ngModel]',
                    providers: [PERCENTAGE_VALIDATOR]
                },] }
    ];
    /** @nocollapse */
    PERCENTAGEValidator.ctorParameters = function () { return []; };
    return PERCENTAGEValidator;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PERCENTAGEPipe = /** @class */ (function () {
    function PERCENTAGEPipe() {
    }
    /**
     * @param {?} percentageValue
     * @return {?}
     */
    PERCENTAGEPipe.prototype.transform = /**
     * @param {?} percentageValue
     * @return {?}
     */
    function (percentageValue) {
        return maskBr.porcentagem(percentageValue);
    };
    PERCENTAGEPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'percentage',
                },] }
    ];
    /** @nocollapse */
    PERCENTAGEPipe.ctorParameters = function () { return []; };
    return PERCENTAGEPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ renavam = function (control) {
    if (utilsBr.isPresent(Validators.required(control))) {
        return null;
    }
    var /** @type {?} */ v = control.value;
    return validateBr.renavam(v) ? null : { renavam: true };
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ RENAVAM_VALIDATOR = {
    provide: NG_VALIDATORS,
    // tslint:disable-next-line: no-use-before-declare
    useExisting: forwardRef(function () { return RenavamValidator; }),
    multi: true
};
var RenavamValidator = /** @class */ (function () {
    function RenavamValidator() {
    }
    /**
     * @param {?} c
     * @return {?}
     */
    RenavamValidator.prototype.validate = /**
     * @param {?} c
     * @return {?}
     */
    function (c) {
        return renavam(c);
    };
    RenavamValidator.decorators = [
        { type: Directive, args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[renavam][formControlName],[renavam][formControl],[renavam][ngModel]',
                    providers: [RENAVAM_VALIDATOR]
                },] }
    ];
    /** @nocollapse */
    RenavamValidator.ctorParameters = function () { return []; };
    return RenavamValidator;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var RenavamPipe = /** @class */ (function () {
    function RenavamPipe() {
    }
    /**
     * @param {?} renavamValue
     * @return {?}
     */
    RenavamPipe.prototype.transform = /**
     * @param {?} renavamValue
     * @return {?}
     */
    function (renavamValue) {
        return maskBr.renavam(renavamValue);
    };
    RenavamPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'renavam',
                },] }
    ];
    /** @nocollapse */
    RenavamPipe.ctorParameters = function () { return []; };
    return RenavamPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ pispasep = function (control) {
    if (utilsBr.isPresent(Validators.required(control))) {
        return null;
    }
    var /** @type {?} */ v = control.value;
    return validateBr.pispasep(v) ? null : { pispasep: true };
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ PISPASE_VALIDATOR = {
    provide: NG_VALIDATORS,
    // tslint:disable-next-line: no-use-before-declare
    useExisting: forwardRef(function () { return PispasepValidator; }),
    multi: true
};
var PispasepValidator = /** @class */ (function () {
    function PispasepValidator() {
    }
    /**
     * @param {?} c
     * @return {?}
     */
    PispasepValidator.prototype.validate = /**
     * @param {?} c
     * @return {?}
     */
    function (c) {
        return pispasep(c);
    };
    PispasepValidator.decorators = [
        { type: Directive, args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[pispasep][formControlName],[pispasep][formControl],[pispasep][ngModel]',
                    providers: [PISPASE_VALIDATOR]
                },] }
    ];
    /** @nocollapse */
    PispasepValidator.ctorParameters = function () { return []; };
    return PispasepValidator;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PispasepPipe = /** @class */ (function () {
    function PispasepPipe() {
    }
    /**
     * @param {?} pispasepValue
     * @return {?}
     */
    PispasepPipe.prototype.transform = /**
     * @param {?} pispasepValue
     * @return {?}
     */
    function (pispasepValue) {
        return maskBr.pispasep(pispasepValue);
    };
    PispasepPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'pispasep',
                },] }
    ];
    /** @nocollapse */
    PispasepPipe.ctorParameters = function () { return []; };
    return PispasepPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ rg = function (control) {
    if (utilsBr.isPresent(Validators.required(control))) {
        return null;
    }
    var /** @type {?} */ v = control.value;
    return validateBr.rg(v) ? null : { rg: true };
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ RG_VALIDATOR = {
    provide: NG_VALIDATORS,
    // tslint:disable-next-line: no-use-before-declare
    useExisting: forwardRef(function () { return RGValidator; }),
    multi: true
};
var RGValidator = /** @class */ (function () {
    function RGValidator() {
    }
    /**
     * @param {?} c
     * @return {?}
     */
    RGValidator.prototype.validate = /**
     * @param {?} c
     * @return {?}
     */
    function (c) {
        return rg(c);
    };
    RGValidator.decorators = [
        { type: Directive, args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[rg][formControlName],[rg][formControl],[rg][ngModel]',
                    providers: [RG_VALIDATOR]
                },] }
    ];
    /** @nocollapse */
    RGValidator.ctorParameters = function () { return []; };
    return RGValidator;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var RGPipe = /** @class */ (function () {
    function RGPipe() {
    }
    /**
     * @param {?} rgValue
     * @return {?}
     */
    RGPipe.prototype.transform = /**
     * @param {?} rgValue
     * @return {?}
     */
    function (rgValue) {
        return maskBr.rg(rgValue);
    };
    RGPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'rg',
                },] }
    ];
    /** @nocollapse */
    RGPipe.ctorParameters = function () { return []; };
    return RGPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ time = function (control) {
    if (utilsBr.isPresent(Validators.required(control))) {
        return null;
    }
    var /** @type {?} */ v = control.value;
    return validateBr.time(v) ? null : { time: true };
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ TIME_VALIDATOR = {
    provide: NG_VALIDATORS,
    // tslint:disable-next-line: no-use-before-declare
    useExisting: forwardRef(function () { return TIMEValidator; }),
    multi: true
};
var TIMEValidator = /** @class */ (function () {
    function TIMEValidator() {
    }
    /**
     * @param {?} c
     * @return {?}
     */
    TIMEValidator.prototype.validate = /**
     * @param {?} c
     * @return {?}
     */
    function (c) {
        return time(c);
    };
    TIMEValidator.decorators = [
        { type: Directive, args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[time][formControlName],[time][formControl],[time][ngModel]',
                    providers: [TIME_VALIDATOR]
                },] }
    ];
    /** @nocollapse */
    TIMEValidator.ctorParameters = function () { return []; };
    return TIMEValidator;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var TIMEPipe = /** @class */ (function () {
    function TIMEPipe() {
    }
    /**
     * @param {?} timeValue
     * @return {?}
     */
    TIMEPipe.prototype.transform = /**
     * @param {?} timeValue
     * @return {?}
     */
    function (timeValue) {
        return maskBr.time(timeValue);
    };
    TIMEPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'time',
                },] }
    ];
    /** @nocollapse */
    TIMEPipe.ctorParameters = function () { return []; };
    return TIMEPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ titulo = function (control) {
    if (utilsBr.isPresent(Validators.required(control))) {
        return null;
    }
    var /** @type {?} */ v = control.value;
    return validateBr.titulo(v) ? null : { titulo: true };
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ TITULO_VALIDATOR = {
    provide: NG_VALIDATORS,
    // tslint:disable-next-line: no-use-before-declare
    useExisting: forwardRef(function () { return TITULOValidator; }),
    multi: true
};
var TITULOValidator = /** @class */ (function () {
    function TITULOValidator() {
    }
    /**
     * @param {?} c
     * @return {?}
     */
    TITULOValidator.prototype.validate = /**
     * @param {?} c
     * @return {?}
     */
    function (c) {
        return titulo(c);
    };
    TITULOValidator.decorators = [
        { type: Directive, args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[titulo][formControlName],[titulo][formControl],[titulo][ngModel]',
                    providers: [TITULO_VALIDATOR]
                },] }
    ];
    /** @nocollapse */
    TITULOValidator.ctorParameters = function () { return []; };
    return TITULOValidator;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var TITULOPipe = /** @class */ (function () {
    function TITULOPipe() {
    }
    /**
     * @param {?} tituloValue
     * @return {?}
     */
    TITULOPipe.prototype.transform = /**
     * @param {?} tituloValue
     * @return {?}
     */
    function (tituloValue) {
        return maskBr.titulo(tituloValue);
    };
    TITULOPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'titulo'
                },] }
    ];
    /** @nocollapse */
    TITULOPipe.ctorParameters = function () { return []; };
    return TITULOPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ NgBrazilValidators = {
    cpf: cpf,
    cnpj: cnpj,
    celular: celular,
    cep: cep,
    currency: currency,
    inscricaoestadual: inscricaoestadual,
    number: number,
    pispasep: pispasep,
    placa: placa,
    porcentagem: porcentagem,
    renavam: renavam,
    rg: rg,
    telefone: telefone,
    time: time,
    titulo: titulo
};
var /** @type {?} */ MASKS = utilsBr.MASKS;
var /** @type {?} */ CustomDirectives = [
    CelularValidator,
    CelularPipe,
    CEPValidator,
    CEPPipe,
    CPFValidator,
    CPFPipe,
    CNPJValidator,
    CNPJPipe,
    CURRENCYValidator,
    CURRENCYPipe,
    InscricaoEstadualValidator,
    InscricaoEstadualPipe,
    NUMBERValidator,
    NUMBERPipe,
    PERCENTAGEValidator,
    PERCENTAGEPipe,
    PispasepValidator,
    PispasepPipe,
    PLACAValidator,
    PLACAPipe,
    RenavamValidator,
    RenavamPipe,
    RGValidator,
    RGPipe,
    TelefoneValidator,
    TelefonePipe,
    TIMEValidator,
    TIMEPipe,
    TITULOValidator,
    TITULOPipe
];
var /** @type {?} */ NgBrDirectives = {
    CelularValidator: CelularValidator,
    CelularPipe: CelularPipe,
    CEPValidator: CEPValidator,
    CEPPipe: CEPPipe,
    CNPJValidator: CNPJValidator,
    CNPJPipe: CNPJPipe,
    CPFValidator: CPFValidator,
    CPFPipe: CPFPipe,
    CURRENCYValidator: CURRENCYValidator,
    CURRENCYPipe: CURRENCYPipe,
    InscricaoEstadualValidator: InscricaoEstadualValidator,
    InscricaoEstadualPipe: InscricaoEstadualPipe,
    NUMBERValidator: NUMBERValidator,
    NUMBERPipe: NUMBERPipe,
    PERCENTAGEValidator: PERCENTAGEValidator,
    PERCENTAGEPipe: PERCENTAGEPipe,
    PispasepValidator: PispasepValidator,
    PispasepPipe: PispasepPipe,
    PLACAValidator: PLACAValidator,
    PLACAPipe: PLACAPipe,
    RGValidator: RGValidator,
    RGPipe: RGPipe,
    RenavamValidator: RenavamValidator,
    RenavamPipe: RenavamPipe,
    TelefoneValidator: TelefoneValidator,
    TelefonePipe: TelefonePipe,
    TIMEValidator: TIMEValidator,
    TIMEPipe: TIMEPipe,
    TITULOValidator: TITULOValidator,
    TITULOPipe: TITULOPipe
};
var NgBrazil = /** @class */ (function () {
    function NgBrazil() {
    }
    /**
     * @return {?}
     */
    NgBrazil.forRoot = /**
     * @return {?}
     */
    function () {
        return {
            ngModule: NgBrazil
        };
    };
    NgBrazil.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        CustomDirectives
                    ],
                    exports: [
                        CustomDirectives
                    ]
                },] }
    ];
    /** @nocollapse */
    NgBrazil.ctorParameters = function () { return []; };
    return NgBrazil;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

export { NgBrazilValidators, MASKS, CustomDirectives, NgBrDirectives, NgBrazil, CelularValidator as ɵp, CelularPipe as ɵq, celular as ɵc, CEPValidator as ɵr, CEPPipe as ɵs, cep as ɵd, CNPJValidator as ɵv, CNPJPipe as ɵw, cnpj as ɵb, CPFValidator as ɵt, CPFPipe as ɵu, cpf as ɵa, CURRENCYValidator as ɵx, CURRENCYPipe as ɵy, currency as ɵe, InscricaoEstadualValidator as ɵz, InscricaoEstadualPipe as ɵba, inscricaoestadual as ɵf, NUMBERValidator as ɵbb, NUMBERPipe as ɵbc, number as ɵg, PERCENTAGEValidator as ɵbd, PERCENTAGEPipe as ɵbe, porcentagem as ɵj, PispasepValidator as ɵbf, PispasepPipe as ɵbg, pispasep as ɵh, PLACAValidator as ɵbh, PLACAPipe as ɵbi, placa as ɵi, RenavamValidator as ɵbj, RenavamPipe as ɵbk, renavam as ɵk, RGValidator as ɵbl, RGPipe as ɵbm, rg as ɵl, TelefoneValidator as ɵbn, TelefonePipe as ɵbo, telefone as ɵm, TIMEValidator as ɵbp, TIMEPipe as ɵbq, time as ɵn, TITULOValidator as ɵbr, TITULOPipe as ɵbs, titulo as ɵo };

//# sourceMappingURL=ng-brazil.js.map